/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
//import {Link} from 'react-router-dom'
//import {toAbsoluteUrl} from '../../../../helpers'
import {useLayout} from '../../../core'

const MegaMenu: FC = () => {
  const {setLayoutType, setToolbarType} = useLayout()
  return (
    <div className='row'>
      {/* begin:Col */}
      <div className='col-lg-12'>
        {/* begin:Row */}
        <div className='row'>
          {/* begin:Col */}
          <div className='col-lg-12 mb-3'>
            {/* begin:Heading */}
            {/* <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Layouts</h4> */}
            {/* end:Heading */}
            {/* begin:Menu item */}
            <div className='menu-item p-0 m-0'>
              {/* begin:Menu link */}
              <a onClick={() => setLayoutType('light-sidebar')} className='menu-link'>
                <span className='menu-bullet'>
                  <span className='bullet bullet-dot bg-gray-300i h-6px w-6px'></span>
                </span>
                <span className='menu-title'>Light Sidebar</span>
              </a>
              {/* end:Menu link */}
            </div>
            {/* end:Menu item */}
            {/* begin:Menu item */}
            <div className='menu-item p-0 m-0'>
              {/* begin:Menu link */}
              <a onClick={() => setLayoutType('dark-sidebar')} className='menu-link'>
                <span className='menu-bullet'>
                  <span className='bullet bullet-dot bg-gray-300i h-6px w-6px'></span>
                </span>
                <span className='menu-title'>Dark Sidebar</span>
              </a>
              {/* end:Menu link */}
            </div>
            {/* end:Menu item */}
           </div>
         
        </div>
        {/* end:Row */}
        {/* <div className='separator separator-dashed mx-lg-5 mt-2 mb-6'></div> */}
       
      </div>
      {/* end:Col */}
    
    </div>
  )
}

export {MegaMenu}
